import { render } from "./ArchiveDetailViewer.vue?vue&type=template&id=57dc4b0a&scoped=true"
import script from "./ArchiveDetailViewer.vue?vue&type=script&lang=js"
export * from "./ArchiveDetailViewer.vue?vue&type=script&lang=js"

import "./ArchiveDetailViewer.vue?vue&type=style&index=0&id=57dc4b0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57dc4b0a"]])

export default __exports__